import { useQuery } from '@tanstack/react-query';
import { getManageDigestPreferences } from '@nomiss/services';

export const manageDigestQueryKeys = {
  preferences: ['manage-digest', 'preferences'] as const,
};

export function useManageDigest(accessToken?: string | null, enabled = true) {
  return useQuery({
    queryKey: [...manageDigestQueryKeys.preferences, accessToken ?? ''],
    queryFn: () => getManageDigestPreferences(accessToken),
    enabled,
  });
}
